const SoFormStepComplements = {
  nameForData: 'SO_FORM_STEP_COMPLEMENTS',
};

export default SoFormStepComplements;
